import React, { useEffect, useRef } from 'react';

export const useSkipDidMountEffect = (
  effect: () => void,
  deps: React.DependencyList
) => {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      effect();
    } else {
      didMountRef.current = true;
    }
  }, deps);
};
